import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GmSection',{staticClass:"host-ack",attrs:{"id":_vm.sectionId,"wrap-class":"host-ack-bg"}},[_c(VRow,[_c(VCol,[_c('SectionTitle',{attrs:{"main":"Acknowledgements","sub":"and Recognition","border-col":"#fff"}})],1)],1),_c(VRow,{staticClass:"card-row"},_vm._l((_vm.acks),function(a){return _c('Card',{key:a.img,attrs:{"img":a.img,"title":a.title,"desc":a.desc}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }